/**
 * Builds a query string supporting both single-value and repeated-key parameters.
 *
 * @param base - Simple key-value pairs (undefined values are skipped)
 * @param repeated - Keys with array values, each element becomes a separate query param
 * @returns Encoded query string (without leading "?")
 *
 * @example
 * buildQueryParams(
 *   { limit: "10", page: "1" },
 *   { platforms: ["twitter", "instagram"], include_keywords: ["crypto"] }
 * )
 * // → "limit=10&page=1&platforms=twitter&platforms=instagram&include_keywords=crypto"
 */
export function buildQueryParams(
  base: Record<string, string | undefined>,
  repeated?: Record<string, string[] | undefined>,
): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(base)) {
    if (value !== undefined) {
      params.append(key, value);
    }
  }

  if (repeated) {
    for (const [key, values] of Object.entries(repeated)) {
      if (values?.length) {
        for (const value of values) {
          params.append(key, value);
        }
      }
    }
  }

  return params.toString();
}
